import React, { useEffect } from "react";
import moment from "moment";
import { useRouter } from "next/router";
import Link from "next/link";
import News_item from "../../components/blog/news_item";
import Meta from "../../components/Meta";
import { getAllPostsWithSlug } from "../../lib/api";
import { getBlogPostStaticProps } from "../../lib/blogPost";
import { contentfulOptions } from "../../lib/contentfulOptions";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import localFont from "next/font/local";
import {
  useContentfulInspectorMode,
  useContentfulLiveUpdates,
} from "@contentful/live-preview/react";

const calSans = localFont({
  src: "../../fonts/CalSans-SemiBold.woff",
  variable: "--font-calSans",
});

const Post = (props) => {
  const router = useRouter();
  const { post, morePosts } = props;
  const livePost = useContentfulLiveUpdates(post);
  const liveMorePosts = useContentfulLiveUpdates(morePosts);
  const inspectorProps = useContentfulInspectorMode({
    entryId: livePost?.sys.id,
  });
  useEffect(() => {
    if (!router.isFallback && !livePost) {
      router.replace("/blog");
    }
  }, []);

  return (
    <div>
      <Meta
        title={livePost?.title}
        image={livePost?.coverImage.url}
        author={livePost?.author.name}
        publishedTime={livePost?.datePublished}
      />
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <img
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <img
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
        />
      </picture>
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- Post --> */}
        <section className="relative py-10">
          <div className="container">
            <header className="mx-auto mb-16 max-w-xl text-center">
              <div className="mb-3 inline-flex flex-wrap items-center space-x-1 text-xs">
                <span className="text-accent inline-flex flex-wrap items-center space-x-1 uppercase">
                  <a href="/blog" {...inspectorProps({ fieldId: "topic" })}>
                    {livePost?.topic}
                  </a>
                </span>
              </div>

              <h1
                className={`${calSans.variable} font-calSans text-jacarta-700 mb-4 text-2xl dark:text-white sm:text-5xl`}
              >
                {livePost?.title}
              </h1>
              {/* <!-- Author --> */}
              <div className="inline-flex items-center">
                <img
                  src={livePost?.author.thumbnail.url}
                  alt="author"
                  className="mr-4 h-10 w-10 shrink-0 rounded-full"
                />

                <div className="text-left">
                  <span className="dark:text-jacarta-200 text-jacarta-700 text-2xs font-medium tracking-tight">
                    {livePost?.author.name}
                  </span>

                  {/* <!-- Date / Time --> */}
                  <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                    <span>
                      <time>
                        {moment(livePost?.datePublished).format(
                          "MMM D, YYYY  hh:mm A"
                        )}
                      </time>
                    </span>
                    <span>•</span>
                    <span>{livePost?.timeToRead} minute read</span>
                  </div>
                </div>
              </div>
            </header>

            {/* <!-- Featured image --> */}
            <figure className="mb-16">
              <img
                src={livePost?.coverImage.url}
                alt={livePost?.coverImage.description}
                className="rounded-2xl w-full"
              />
            </figure>

            {/* <!-- Article --> */}
            <article className="mb-8">
              {/* <!-- Content --> */}
              <div
                id="article-content"
                className="article-content"
                dangerouslySetInnerHTML={{
                  __html: documentToHtmlString(
                    livePost?.bodyCopy.json,
                    contentfulOptions
                  ),
                }}
              />
            </article>

            <div className="mx-auto max-w-[48.125rem]">
              {/* <!-- Share --> */}
              <div className="mb-8 flex items-center">
                <span className="dark:text-jacarta-300 mr-4 text-sm font-bold">
                  Share:
                </span>
                <div className="flex space-x-2">
                  {/* <a
                    href="#"
                    className="group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="facebook"
                      className="fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
                    </svg>
                  </a> */}
                  <a
                    href={`https://twitter.com/intent/tweet?text=Check out this blog livePost by Blue Quanta LLC&url=https://www.bluequanta.io/blog/${post?.slug}`}
                    className="group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="twitter"
                      className="fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                    </svg>
                  </a>
                  <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=https://www.bluequanta.io/blog/${post?.slug}`}
                    className="group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="linkedin"
                      className="fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                    </svg>
                  </a>
                  <a
                    href={`mailto:?subject=Check out this blog post...&amp;body=I thought you might like this blog post: http://www.bluequanta.io/blog/${post?.slug}.`}
                    title="Share by Email"
                    className="group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent"
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fab"
                      data-icon="email"
                      className="fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="flex justify-center space-x-4 mb-8">
                <Link
                  href="/contact"
                  className="bg-accent shadow-accent-volume hover:bg-accent-dark w-37 rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                >
                  Contact Us Now
                </Link>
              </div>
              {/* <!-- Author --> */}
              <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2xl mb-8 flex border bg-white p-8">
                <img
                  src={post?.author.thumbnail.url}
                  alt="author"
                  className="mr-4 h-16 w-16 shrink-0 self-start rounded-lg md:mr-8 md:h-[9rem] md:w-[9rem]"
                />
                <div>
                  <span className="text-jacarta-700 font-display mb-3 mt-2 block text-base dark:text-white">
                    {post?.author.name}
                  </span>
                  <p className="dark:text-jacarta-300 mb-4">
                    {post?.author.biography}
                  </p>
                  <div className="flex space-x-5">
                    {post?.author.facebookUrl && (
                      <a href={post?.author.facebookUrl} className="group">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fab"
                          data-icon="facebook"
                          className="group-hover:fill-accent fill-jacarta-400 h-4 w-4 dark:group-hover:fill-white"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
                        </svg>
                      </a>
                    )}
                    {post?.author.twitterUrl && (
                      <a href={post?.author.twitterUrl} className="group">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fab"
                          data-icon="twitter"
                          className="group-hover:fill-accent fill-jacarta-400 h-4 w-4 dark:group-hover:fill-white"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                        </svg>
                      </a>
                    )}
                    {post?.author.linkedInUrl && (
                      <a href={post?.author.linkedInUrl} className="group">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fab"
                          data-icon="linkedin"
                          className="group-hover:fill-accent fill-jacarta-400 h-4 w-4 dark:group-hover:fill-white"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                        </svg>
                      </a>
                    )}

                    {post?.author.instagramUrl && (
                      <a href={post?.author.instagramUrl} className="group">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fab"
                          data-icon="instagram"
                          className="group-hover:fill-accent fill-jacarta-400 h-4 w-4 dark:group-hover:fill-white"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* <!-- Related --> */}
              {liveMorePosts?.length > 0 && (
                <h2 className="font-display text-jacarta-700 mb-8 text-3xl dark:text-white">
                  Related Posts
                </h2>
              )}

              {/* <div className="grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2">
						</div> */}
              {/* <!-- Posts --> */}
              <News_item
                data={liveMorePosts?.slice(0, 3)}
                classes="grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2"
              />
            </div>
            {/* <!-- end related --> */}
          </div>
        </section>
        {/* <!-- end post --> */}
      </div>
    </div>
  );
};

export default Post;

export async function getStaticProps({ params, draftMode = false }) {
  return getBlogPostStaticProps(params.slug, draftMode);
}

export async function getStaticPaths() {
  const allPosts = await getAllPostsWithSlug();

  return {
    paths: allPosts?.map(({ slug }) => `/blog/${slug}`) ?? [],
    fallback: true,
  };
}
